module.exports = __webpack_public_path__ + "img/avatar2.d2323af2.png";